<template>
  <div>
    <div class="gallery-container">

      <h3>I don't like Instagram and VSCO is shit now so</h3>
      <h1>These are some photos</h1>

      <div class="photo-container">
        <template v-for="item in orderedItems" :key="item.id">
          <div
            v-if="item.type === 'group'"
            class="special-photo-container"
          >
            <img
              v-if="gallery.groups[item.value] && gallery.groups[item.value].length"
              :src="thumbnailUrl(groupCover(item.value), 640)"
              :srcset="thumbnailSrcSet(groupCover(item.value))"
              :sizes="thumbnailSizes"
              class="photo special-photo"
              @click="showModal = item.value"
              @error="onThumbnailError($event, groupCover(item.value))"
              loading="lazy"
              decoding="async"
            />
            <span class="overlay-text">{{ item.value }}</span>
          </div>
          <img
            v-else
            :src="thumbnailUrl(item.value, 640)"
            :srcset="thumbnailSrcSet(item.value)"
            :sizes="thumbnailSizes"
            @error="onThumbnailError($event, item.value)"
            loading="lazy"
            decoding="async"
          />
        </template>
      </div>
    </div>

    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <button @click="showModal = null" class="close-button">Close</button>
        <div class="expanded-photos">
          <img
            v-for="(photo, index) in (gallery.groups[showModal] || [])"
            :key="index"
            :src="photo"
            class="additional-photo"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: null,
      gallery: { images: [], groups: {} },
      thumbnailSizes: '(max-width: 600px) 48vw, (max-width: 900px) 31vw, 19vw',
      fallback: {
        images: [
          "/photos/IMG_1976.jpg",
          "/photos/IMG_1837.png",
          "/photos/DSCF0487.jpg",
          "/photos/DSCF0485.jpg",
          "/photos/DSCF0478.jpg",
          "/photos/Spain2024/DSCF0323.jpg",
          "/photos/Uk2024/DSCF0140.jpg",
          "/photos/IMG_2066.png",
          "/photos/IMG_1123.jpg",
          "/photos/DSCF0104.jpg",
          "/photos/DSCF0112.jpg",
          "/photos/DSCF0043.jpg",
          "/photos/DSCF0035.jpg",
          "/photos/DSCF0048.jpg",
          "/photos/guitar.jpg",
          "/photos/unnamed.jpg",
          "/photos/000234240005 (1).jpg",
          "/photos/000234240025.jpg",
          "/photos/000234240008.jpg",
          "/photos/IMG_0245.jpg",
          "/photos/IMG_9946.jpg",
          "/photos/IMG_9738.jpg",
          "/photos/IMG_9633.jpg",
          "/photos/IMG_9336.jpg",
          "/photos/IMG20231123105744.jpg",
          "/photos/IMG_9083.jpg",
          "/photos/IMG_8711.jpg",
          "/photos/IMG_8473.jpg",
          "/photos/IMG_8304.jpg",
          "/photos/IMG_7794.jpg",
          "/photos/IMG_7041.jpg",
          "/photos/IMG_6807.jpg",
          "/photos/IMG_6587.jpg",
          "/photos/IMG_6576.jpg",
          "/photos/IMG_6539.jpg",
          "/photos/IMG_7330.jpg",
          "/photos/IMG_7197.jpg",
          "/photos/IMG_7321.jpg",
          "/photos/IMG_7301-VSCO.jpg",
          "/photos/IMG_7344.png",
          "/photos/IMG_6906.jpg",
          "/photos/IMG_5710.jpg",
          "/photos/IMG_5566.jpg",
          "/photos/IMG_7670.jpg",
          "/photos/IMG_4535.jpg",
          "/photos/IMG_6152-VSCO.jpg",
          "/photos/IMG_5317.jpg",
          "/photos/IMG_0477.jpg",
          "/photos/IMG_20191211_115235-VSCO.jpg",
          "/photos/IMG20191205145500.jpg",
          "/photos/P1050988-VSCO.jpg",
          "/photos/IMG20191205173330.jpg",
          "/photos/P1060005.jpg",
          "/photos/IMG_20191206_113250.jpg",
          "/photos/IMG20191206130737.jpg",
          "/photos/IMG20191204112835.jpg",
          "/photos/IMG20191203113145-VSCO.jpg",
          "/photos/IMG20191116192705-VSCO.jpg",
          "/photos/969-VSCO.jpg",
          "/photos/CSHR.jpg",
          "/photos/received_490326714679845.jpeg",
          "/photos/P1040058.jpg",
          "/photos/RC29MNY.jpg",
          "/photos/3906-VSCO.jpg",
          "/photos/IMG_0185-VSCO.jpg",
          "/photos/IMG_1962-VSCO.jpg",
          "/photos/IMG_8575-VSCO.jpg"
        ],
        groups: {
          Uk2024: [
            "/photos/Uk2024/DSCF0140.jpg",
            "/photos/Uk2024/DSCF0142.jpg",
            "/photos/Uk2024/DSCF0161.jpg",
            "/photos/Uk2024/DSCF0199.jpg",
            "/photos/Uk2024/DSCF0206.jpg",
            "/photos/Uk2024/DSCF0209.jpg",
            "/photos/Uk2024/DSCF0217.jpg",
            "/photos/Uk2024/DSCF0219.jpg",
            "/photos/Uk2024/DSCF0226.jpg",
            "/photos/Uk2024/DSCF0231.jpg",
            "/photos/Uk2024/DSCF0248.jpg",
            "/photos/Uk2024/DSCF0259.jpg",
            "/photos/Uk2024/DSCF0272.jpg",
            "/photos/Uk2024/DSCF0273.jpg",
            "/photos/Uk2024/DSCF0292.jpg"
          ],
          Spain2024: [
            "/photos/Spain2024/DSCF0323.jpg",
            "/photos/Spain2024/IMG_1616.jpg",
            "/photos/Spain2024/DSCF0330.jpg",
            "/photos/Spain2024/DSCF0334.jpg",
            "/photos/Spain2024/DSCF0342.jpg",
            "/photos/Spain2024/DSCF0357.jpg",
            "/photos/Spain2024/DSCF0358.jpg",
            "/photos/Spain2024/DSCF0370.jpg",
            "/photos/Spain2024/DSCF0374.jpg",
            "/photos/Spain2024/DSCF0375.jpg",
            "/photos/Spain2024/DSCF0388.jpg",
            "/photos/Spain2024/DSCF0399.jpg",
            "/photos/Spain2024/DSCF0404.jpg",
            "/photos/Spain2024/DSCF0423.jpg",
            "/photos/Spain2024/DSCF0425.jpg",
            "/photos/Spain2024/DSCF0431.jpg",
            "/photos/Spain2024/DSCF0434.jpg",
            "/photos/Spain2024/DSCF0452.jpg"
          ]
        }
      }
    }
  },
  computed: {
    orderedItems() {
      const items = []
      const groups = this.gallery.groups || {}
      const images = this.gallery.images || []
      const groupOrder = Array.isArray(this.gallery.groupOrder) ? this.gallery.groupOrder : Object.keys(groups)
      const itemOrder = Array.isArray(this.gallery.itemOrder) ? this.gallery.itemOrder : null
      const seenGroups = new Set()
      const seenImages = new Set()

      if (itemOrder) {
        for (const token of itemOrder) {
          if (typeof token !== 'string') continue
          if (token.startsWith('group:')) {
            const groupName = token.slice('group:'.length)
            if (groups[groupName] && !seenGroups.has(groupName)) {
              items.push({ type: 'group', value: groupName, id: `group-${groupName}` })
              seenGroups.add(groupName)
            }
            continue
          }
          if (token.startsWith('image:')) {
            const imagePath = token.slice('image:'.length)
            if (images.includes(imagePath) && !seenImages.has(imagePath)) {
              items.push({ type: 'image', value: imagePath, id: imagePath })
              seenImages.add(imagePath)
            }
          }
        }
      }

      for (const groupName of groupOrder) {
        if (groups[groupName] && !seenGroups.has(groupName)) {
          items.push({ type: 'group', value: groupName, id: `group-${groupName}` })
          seenGroups.add(groupName)
        }
      }

      for (const img of images) {
        if (!seenImages.has(img)) {
          items.push({ type: 'image', value: img, id: img })
          seenImages.add(img)
        }
      }

      return items
    }
  },
  methods: {
    groupCover(groupName) {
      const photos = this.gallery.groups[groupName] || []
      return photos.length ? photos[0] : ''
    },
    thumbnailUrl(photoPath, width = 640) {
      if (!photoPath) return ''
      const rel = photoPath.replace(/^\/photos\//, '')
      const base = rel.replace(/\.[^/.]+$/, '')
      return `/photos/.thumbs/w${width}/${base}.webp`
    },
    thumbnailSrcSet(photoPath) {
      if (!photoPath) return ''
      return [320, 640, 960].map((w) => `${this.thumbnailUrl(photoPath, w)} ${w}w`).join(', ')
    },
    onThumbnailError(event, originalSrc) {
      const img = event && event.target
      if (!img) return
      if (img.dataset.originalApplied === '1') return
      img.dataset.originalApplied = '1'
      img.removeAttribute('srcset')
      img.src = originalSrc
    }
  },
  async mounted() {
    try {
      const r = await fetch(`/photos/index.json?t=${Date.now()}`)
      if (r.ok) {
        this.gallery = await r.json()
      } else {
        // try admin API
        const r2 = await fetch('/api/gallery')
        if (r2.ok) this.gallery = await r2.json()
        else this.gallery = this.fallback
      }
    } catch (e) {
      this.gallery = this.fallback
    }
  }
}
</script>

<style scoped>
.gallery-container {
  position: fixed;
  top: 0%;
  left: 5%;
  right: 5%;
  bottom: 7%;
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.gallery-container::-webkit-scrollbar {
  display: none;
}

h1 {
  text-decoration: underline;
  margin-top: -1%;
  margin-bottom: 2.5%;
}

h3 {
  font-weight: 500;
  font-size: medium;
  margin-top: 2.5%;
}

  .photo-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  justify-items: center;
  align-items: center;
  padding-left: 3%;
  padding-right: 3%;
}

  .photo-container img {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.photo {
  cursor: pointer;
}

.special-photo-container {
  position: relative;
  display: inline-block;
}

.special-photo {
  border-right: 7px solid grey;
  border-bottom: 7px solid grey;
  padding: 0px;
}

.overlay-text {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 16px;
  pointer-events: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  max-width: 80%;
  max-height: 80%;
  overflow-y: auto;
}

.close-button {
  background: #ff6600;
  border: none;
  color: white;
  padding: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}

.expanded-photos {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.additional-photo {
  width: 100%;
  height: 300px;
  object-fit: cover;
}

@media (max-width: 900px) {
  .photo-container { grid-template-columns: repeat(3, 1fr); }
}

@media (max-width: 600px) {
  .photo-container { grid-template-columns: repeat(2, 1fr); }
  .photo-container img { height: 220px; }
  .expanded-photos { grid-template-columns: repeat(1, 1fr); }
}
</style>
  
